import { Account } from 'src/components/embedded-account';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { PageComponent } from 'src/types';

const AccountPage: PageComponent = Account;

AccountPage.layout = CoreMenuLayout;
export default AccountPage;
